export default __webpack_public_path__ + "static/RobustOpenFieldTracking-861a480367eb835601023e41bb83737a.png";